import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Api } from '../api'
import type { Feature } from '../feature'

/**
 * Handles `deleteOverride.request` actions: forwards the request to the
 * API and dispatches success/error actions.
 */
export const executeDeleteOverride = store.effects.create(
  (feature: Feature, api: Api, meFeature: me.Feature) =>
    feature.actions.deleteOverride.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.mergeMap(([action, context]) => {
        const request = action.data
        if (!context) {
          return rxjs.of(
            feature.actions.deleteOverride.error.from(action).create({
              error: new Error('Cannot determine current context'),
              request,
            }),
          )
        }
        return api.deleteOverride(context, request).pipe(
          rxjs.map(() =>
            feature.actions.deleteOverride.success
              .from(action)
              .create({ request, response: undefined }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.deleteOverride.error
                .from(action)
                .create({ error, request }),
            ),
          ),
        )
      }),
    ),
)
